module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/sink/sink.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/sink/sink.png
// module id = 626
// module chunks = 0